import { useEffect, useState } from 'react';
import { AuthSheet } from './AuthSheet';
import { AuthForm, type AuthMode } from './AuthForm';

/**
 * Envase "sheet" de la autenticación del onboarding (ver ADR-704). Un único sheet
 * persistente cuyo contenido cambia entre modos (signup ↔ login ↔ forgot) — así
 * "abrir el de login" desde signup es un swap suave en vez de un cierre+apertura
 * brusco (ADR-704).
 *
 * **Sólo desktop** desde ADR-2026-07-30-registro-pantalla-completa: en mobile el CTA
 * del carrusel ya no abre este bottom sheet, sino que navega a `/registro` (pantalla
 * completa). El formulario en sí vive en `AuthForm` y lo comparten los dos envases.
 */

export type { AuthMode };

const TITLE_ID = 'auth-sheet-title';

export interface AuthSheetsProps {
  mode: AuthMode | null;
  onModeChange: (mode: AuthMode) => void;
  onClose: () => void;
}

export function AuthSheets({ mode, onModeChange, onClose }: AuthSheetsProps) {
  // Conserva el último modo visible durante la animación de salida (cuando
  // `mode` ya es null pero el sheet sigue montado).
  const [renderMode, setRenderMode] = useState<AuthMode>('signup');
  useEffect(() => {
    if (mode) setRenderMode(mode);
  }, [mode]);

  return (
    <AuthSheet open={mode !== null} onClose={onClose} titleId={TITLE_ID}>
      <AuthForm
        mode={renderMode}
        onModeChange={onModeChange}
        titleId={TITLE_ID}
        variant="sheet"
      />
    </AuthSheet>
  );
}

export default AuthSheets;
